// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateSuccess_wrapper__na3gM","content":"CreateSuccess_content__IboCU","success":"CreateSuccess_success__-yXox"};